<router-outlet />
<div class="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div class="container">
    <div class="container-xxl py-5">
      <div class="container">
        <!-- <div class="row g-4 center-content">
          <div class="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
            <a class="facility-item" href="mediacenter/photo">
              <div class="facility-icon bg-primary">
                <span class="bg-primary"></span>
                <i class="fa fa-image fa-3x text-primary"></i>
                <span class="bg-primary"></span>
              </div>
              <div class="facility-text bg-primary">
                <h3 class="text-primary mb-3">
                  {{ "photo_gallery" | translate }}
                </h3>
                <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
            <a class="facility-item" href="mediacenter/video">
              <div class="facility-icon bg-success">
                <span class="bg-success"></span>
                <i class="fa fa-film fa-3x text-success"></i>
                <span class="bg-success"></span>
              </div>
              <div class="facility-text bg-success">
                <h3 class="text-success mb-3">
                  {{ "video_gallery" | translate }}
                </h3>
                <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p>
              </div>
            </a>
          </div>
        </div>
        <br />
        <br /> -->
        <div class="row g-4 center-content">
          <div class="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
            <a class="facility-item" href="mediacenter/press">
              <div class="facility-icon bg-warning">
                <span class="bg-warning"></span>
                <i class="fa fa-newspaper fa-3x text-warning"></i>
                <span class="bg-warning"></span>
              </div>
              <div class="facility-text bg-warning">
                <h3 class="text-warning mb-3">
                  {{ "press_release" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </a>
          </div>
          <div class="col-lg-4 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
            <a class="facility-item" href="mediacenter/radio">
              <div class="facility-icon bg-danger">
                <span class="bg-danger"></span>
                <i class="fa fa-broadcast-tower fa-3x text-danger"></i>
                <span class="bg-danger"></span>
              </div>
              <div class="facility-text bg-danger">
                <h3 class="text-danger mb-3">
                  {{ "radio" | translate }}
                </h3>
                <!-- <p class="mb-0">
                  Eirmod sed ipsum dolor sit rebum magna erat lorem kasd vero
                  ipsum sit
                </p> -->
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
